module.exports = __webpack_public_path__ + "img/heygov.8654841d.svg";